module.exports = __webpack_public_path__ + "static/media/card_7.4b144d33.png";